"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpService = void 0;
var http_client_1 = require("@wix/http-client");
var retryUtils_1 = require("./retryUtils");
var parseResponse = function (response) { return response.data; };
var HttpService = /** @class */ (function () {
    function HttpService(params) {
        var _this = this;
        this.revalidateAndRetry = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var prevAppInstance, retryConfig, _a, e_1, _b, authorization, headers;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        prevAppInstance = this.appInstance;
                        this.appInstance = null;
                        retryConfig = error.config.retryConfig;
                        if (retryConfig.revalidateAttempt >= retryConfig.maxRevalidate) {
                            console.warn("Max retries with revalidation reached");
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        if (!this.revalidateAppInstance) {
                            console.warn("\"revalidateAppInstance\" wasn't provided");
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        _a = this;
                        return [4 /*yield*/, this.revalidateAppInstance()];
                    case 2:
                        _a.appInstance = _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _c.sent();
                        console.warn("Error while revalidating session:", e_1);
                        return [3 /*break*/, 4];
                    case 4:
                        if (this.appInstance && this.appInstance !== prevAppInstance) {
                            error.config.retryConfig.revalidateAttempt++;
                            _b = error.config.headers || {}, authorization = _b.authorization, headers = __rest(_b, ["authorization"]);
                            return [2 /*return*/, this.httpClient.request(__assign(__assign({}, error.config), { headers: headers }))];
                        }
                        return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); };
        this.retry = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var retryConfig, useExponentialBackoff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        retryConfig = error.config.retryConfig;
                        if (retryConfig.retryAttempt >= retryConfig.maxRetry) {
                            console.warn("Max retries reached");
                            return [2 /*return*/, Promise.reject(error)];
                        }
                        useExponentialBackoff = (0, retryUtils_1.isNetworkError)(error);
                        return [4 /*yield*/, (0, retryUtils_1.backoffDelay)(error.config, useExponentialBackoff)];
                    case 1:
                        _a.sent();
                        retryConfig.retryAttempt++;
                        return [2 /*return*/, this.httpClient.request(error.config)];
                }
            });
        }); };
        this.onError = function (error) { return __awaiter(_this, void 0, void 0, function () {
            var shouldRetryFn;
            return __generator(this, function (_a) {
                // if request is cancelled
                if (http_client_1.HttpClient.isCancel(error)) {
                    return [2 /*return*/, Promise.reject(error)];
                }
                if ((0, retryUtils_1.shouldRevalidateInstance)(error)) {
                    return [2 /*return*/, this.revalidateAndRetry(error)];
                }
                shouldRetryFn = error.config.retryConfig.shouldRetry || retryUtils_1.shouldRetryRequest;
                if (shouldRetryFn(error)) {
                    return [2 /*return*/, this.retry(error)];
                }
                return [2 /*return*/, Promise.reject(error)];
            });
        }); };
        var _a = params || {}, _b = _a.baseURL, baseURL = _b === void 0 ? '' : _b, appInstance = _a.appInstance, revalidateAppInstance = _a.revalidateAppInstance, additionalHeaders = _a.additionalHeaders;
        this.httpClient = new http_client_1.HttpClient({
            getAppToken: function () { return _this.appInstance; },
        });
        // @ts-expect-error
        this.httpClient.client.interceptors.response.use(null, this.onError);
        this.baseURL = baseURL;
        this.appInstance = appInstance;
        this.additionalHeaders = additionalHeaders;
        this.revalidateAppInstance = revalidateAppInstance;
    }
    HttpService.prototype.setBaseURL = function (baseURL) {
        this.baseURL = baseURL;
    };
    HttpService.prototype.setAppInstance = function (appInstance) {
        this.appInstance = appInstance;
    };
    HttpService.prototype.setRevalidateAppInstance = function (revalidateAppInstance) {
        this.revalidateAppInstance = revalidateAppInstance;
    };
    HttpService.prototype.request = function (requestConfig) {
        return this.httpClient
            .request(__assign(__assign({ baseURL: this.baseURL }, requestConfig), { headers: __assign(__assign({}, (this.additionalHeaders || {})), (requestConfig.headers || {})), withCredentials: this.baseURL !== '', retryConfig: __assign(__assign({}, retryUtils_1.RETRY_CONFIG_DEFAULT), (requestConfig.retryConfig || {})) }))
            .then(parseResponse);
    };
    return HttpService;
}());
exports.HttpService = HttpService;
//# sourceMappingURL=index.js.map